module.exports = __webpack_public_path__ + "static/media/whatsapp.41d556e9.svg";